(function () {
  function getMediaSliderState(section) {
    if (!section) return [];

    return Array.from(section.querySelectorAll(".product__media-wrapper")).map(
      (wrapper, index) => {
        const mediaList = wrapper.querySelector(".js-media-list");
        const activeSlide =
          mediaList?.swiper?.slides?.[mediaList.swiper.activeIndex] || null;

        return {
          index,
          activeIndex: mediaList?.swiper?.activeIndex ?? 0,
          activeMediaId: activeSlide?.dataset?.mediaId || null,
        };
      }
    );
  }

  function restoreMediaSliderState(section, sliderState) {
    if (!section || !sliderState?.length) return;

    const wrappers = Array.from(section.querySelectorAll(".product__media-wrapper"));

    sliderState.forEach((state) => {
      const wrapper = wrappers[state.index];
      const mediaList = wrapper?.querySelector(".js-media-list");
      const subList = wrapper?.querySelector(".js-media-sublist");
      const slider = mediaList?.swiper;

      if (!slider) return;

      let targetIndex = state.activeIndex;

      if (state.activeMediaId) {
        const targetSlide = Array.from(slider.slides).find(
          (slide) => slide.dataset.mediaId === state.activeMediaId
        );

        if (targetSlide) {
          targetIndex = slider.slides.indexOf(targetSlide);
        }
      }

      if (targetIndex < 0) return;

      slider.slideTo(targetIndex, 0);
      subList?.swiper?.slideTo(targetIndex, 0);
    });
  }

  function swiperInit(section) {
    if (!section) return;
    subSliderInit(section);
    sliderInit(section);
    popupSliderInit(section);
  }

  function swiperUpdate(section) {
    if (!section) return;
    const sliderState = getMediaSliderState(section);

    section.querySelectorAll(".js-media-list").forEach((element) => {
      element.swiper?.destroy();
    });
    section.querySelectorAll(".js-media-sublist").forEach((element) => {
      element.swiper?.destroy();
    });
    section.querySelectorAll(".js-popup-slider").forEach((element) => {
      element.swiper?.destroy();
    });

    subSliderInit(section);
    sliderInit(section);
    popupSliderInit(section);
    restoreMediaSliderState(section, sliderState);
  }

  function observeSectionResize(section) {
    if (!section) return;
    let previousWidth = window.innerWidth;

    const onResize = () => {
      const currentWidth = window.innerWidth;

      if (currentWidth === previousWidth) return;

      previousWidth = currentWidth;
      swiperUpdate(section);
    };
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit(e.target);
    observeSectionResize(e.target);
  });

  swiperInit(document.currentScript?.parentElement);
  observeSectionResize(document.currentScript?.parentElement);
})();
